import * as React from 'react';
import ProductPOP from './ProductPOP';
import {IProduct} from "../../functions/Interfaces";

class ProductCatalog extends React.Component<any, { products: IProduct[] }> {
  public render() {
    const rows: any = [];
    this.props.products.forEach((product: IProduct) => {
      rows.push(
        <ProductPOP
          product={product}
          key={product.id}
          actionUp={this.props.actionUpdate}
        />
      );
    });
    return <div>{rows}</div>;
  }
}
export default ProductCatalog;


// WEBPACK FOOTER //
// ./src/components/product/ProductCatalog.tsx